import { z } from 'zod';

export const EnvoyCandidateSearchFiltersSaveFormSchema = z.object({
  name: z.string(),
  createAlert: z.boolean().nullish(),
});

export type EnvoyCandidateSearchFiltersSaveForm = z.infer<
  typeof EnvoyCandidateSearchFiltersSaveFormSchema
>;
